<template>
  <router-view></router-view>
</template>


<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      db: '',
      isIos: false,
      isInStandaloneMode: false,
      userAgent: window.navigator.userAgent.toLowerCase()
    }
  },
  computed: {
    ...mapGetters('_Notifier', ['notifsPersistantes'])
  },

  created () {
    // test si pwa sur ios
    this.isIos = /iphone|ipad|ipod/.test(this.userAgent)
    // si pwa deja installé sur mobile
    this.isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator.standalone)
    // si sur ios et pas encore installer on affiche une popup
    if (this.isIos && !this.isInStandaloneMode) {
      // this.setState({ showInstallMessage: true })
      console.log('affiche la popup sur ios')
    } else {
      console.log('pas besoin de popup', self.location.origin)
    }
    // console.log('--> app : this.$route.query.directChat', this.$route.query.directChat)
    // si il y a une demande d'ouverture direct de chat au login
    // if (this.$route.query.directChat) {
    //   // this.directChat = this.$route.query.directChat
    //   sessionStorage.setItem('tf-directChat', this.$route.query.directChat)
    // } else {
    //   sessionStorage.removeItem('tf-directChat')
    // }
    // console.log('--> updateDocumentTitle 1')
    this.updateDocumentTitle()
  },

  watch: {
    '$route.name': function (v) {
      // console.log('--> updateDocumentTitle 2')
      this.updateDocumentTitle()
    },
    notifsPersistantes: function (v) {
      // console.log('--> updateDocumentTitle 3')
      this.updateDocumentTitle()
    }
  },
  methods: {
    updateDocumentTitle () {
      // console.log('this.$route.meta.title', this.$route.meta.title)
      // console.log('this.$route.name', this.$route.name)
      let title = this.$route.meta.title
        ? this.$tc(this.$route.meta.title, 2, { count: '' })
        : this.$tc(this.$route.name, 2, { count: '' })
      title = title.charAt(0).toUpperCase() + title.slice(1)
      console.log('route title', title)
      let notif = this.notifsPersistantes.length
      let notifStr = notif ? '(' + notif + ') ' : ''
      document.title = notifStr + title
      let faviconDefault = './static/icon_tf.png'
      let faviconNotif = './static/icon_tf_notif.png'
      if (notif) {
        changeFavicon(faviconNotif)
      } else {
        changeFavicon(faviconDefault)
      }
    }
  }
}
function changeFavicon (src) {
  let link = document.createElement('link')
  let oldLink = document.getElementById('dynamic-favicon')
  link.id = 'dynamic-favicon'
  link.rel = 'shortcut icon'
  link.href = src
  if (oldLink) {
    document.head.removeChild(oldLink)
  }
  document.head.appendChild(link)
}
</script>

<style scoped>
  div#app {
    background-color: rgba(237, 246, 254, 1);
  }
</style>



// WEBPACK FOOTER //
// src/App.vue